import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import ImageOverlayEditor from "./ImageOverlayEditor";
import RotatedImageOverlay from "./RotatedImageOverlay";

export const IMAGE_OVERLAY_PANE = "imageOverlayPane";

const ImageOverlayLayer = ({
  overlays,
  editingId,
  setOverlayBounds,
  setOverlayRotation,
}) => {
  const map = useMap();
  const [paneReady, setPaneReady] = useState(false);

  useEffect(() => {
    if (!map.getPane(IMAGE_OVERLAY_PANE)) {
      map.createPane(IMAGE_OVERLAY_PANE);
      map.getPane(IMAGE_OVERLAY_PANE).style.zIndex = 350;
    }
    setPaneReady(true);
  }, [map]);

  if (!paneReady) return null;

  const visibleOverlays = overlays.filter((overlay) => overlay.visible);
  const editingOverlay = overlays.find(
    (overlay) => overlay.id === editingId && overlay.visible
  );

  const overlayImages = visibleOverlays.map((overlay) => (
    <RotatedImageOverlay
      key={overlay.id}
      url={overlay.url}
      bounds={overlay.bounds}
      rotation={overlay.rotation}
      opacity={overlay.opacity}
      pane={IMAGE_OVERLAY_PANE}
    />
  ));

  return (
    <>
      {overlayImages}
      {editingOverlay && (
        <ImageOverlayEditor
          overlay={editingOverlay}
          setOverlayBounds={setOverlayBounds}
          setOverlayRotation={setOverlayRotation}
        />
      )}
    </>
  );
};

export default ImageOverlayLayer;
